var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlagOfTheUnitedStates1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 21,
    viewBox: "0 0 31 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_185_14990)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.000976562,
    width: 31,
    height: 21,
    rx: 2.625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.001 0H0.000976562V21H31.001V0Z",
    fill: "#B22234"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000976562 2.4231H31.001H0.000976562ZM31.001 5.65387H0.000976562H31.001ZM0.000976562 8.88463H31.001H0.000976562ZM31.001 12.1154H0.000976562H31.001ZM0.000976562 15.3462H31.001H0.000976562ZM31.001 18.5769H0.000976562H31.001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000976562 2.4231H31.001M31.001 5.65387H0.000976562M0.000976562 8.88463H31.001M31.001 12.1154H0.000976562M0.000976562 15.3462H31.001M31.001 18.5769H0.000976562",
    stroke: "white",
    strokeWidth: 1.61538
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.401 0H0.000976562V11.3077H12.401V0Z",
    fill: "#3C3B6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.03507 0.484619L1.33015 1.65352L0.557617 0.9311H1.51252L0.739988 1.65352L1.03507 0.484619Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.03507 2.74615L1.33015 3.91506L0.557617 3.19264H1.51252L0.739988 3.91506L1.03507 2.74615Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.03507 5.00769L1.33015 6.17659L0.557617 5.45417H1.51252L0.739988 6.17659L1.03507 5.00769Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.03507 7.26929L1.33015 8.43819L0.557617 7.71577H1.51252L0.739988 8.43819L1.03507 7.26929Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.03507 9.53076L1.33015 10.6997L0.557617 9.97724H1.51252L0.739988 10.6997L1.03507 9.53076Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.06827 1.61536L2.36336 2.78426L1.59082 2.06184H2.54573L1.77319 2.78426L2.06827 1.61536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.06827 3.87689L2.36336 5.0458L1.59082 4.32337H2.54573L1.77319 5.0458L2.06827 3.87689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.06827 6.13843L2.36336 7.30733L1.59082 6.58491H2.54573L1.77319 7.30733L2.06827 6.13843Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.06827 8.39996L2.36336 9.56887L1.59082 8.84644H2.54573L1.77319 9.56887L2.06827 8.39996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.10148 0.484619L3.39656 1.65352L2.62402 0.9311H3.57893L2.80639 1.65352L3.10148 0.484619Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.10148 2.74615L3.39656 3.91506L2.62402 3.19264H3.57893L2.80639 3.91506L3.10148 2.74615Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.10148 5.00769L3.39656 6.17659L2.62402 5.45417H3.57893L2.80639 6.17659L3.10148 5.00769Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.10148 7.26929L3.39656 8.43819L2.62402 7.71577H3.57893L2.80639 8.43819L3.10148 7.26929Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.10148 9.53076L3.39656 10.6997L2.62402 9.97724H3.57893L2.80639 10.6997L3.10148 9.53076Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.1337 1.61542L4.42879 2.78432L3.65625 2.0619H4.61116L3.83862 2.78432L4.1337 1.61542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.1337 3.87695L4.42879 5.04586L3.65625 4.32343H4.61116L3.83862 5.04586L4.1337 3.87695Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.1337 6.13849L4.42879 7.30739L3.65625 6.58497H4.61116L3.83862 7.30739L4.1337 6.13849Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.1337 8.40009L4.42879 9.56899L3.65625 8.84657H4.61116L3.83862 9.56899L4.1337 8.40009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.16886 0.48468L5.46394 1.65358L4.69141 0.931162H5.64631L4.87378 1.65358L5.16886 0.48468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.16886 2.74622L5.46394 3.91512L4.69141 3.1927H5.64631L4.87378 3.91512L5.16886 2.74622Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.16886 5.00769L5.46394 6.17659L4.69141 5.45417H5.64631L4.87378 6.17659L5.16886 5.00769Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.16886 7.26929L5.46394 8.43819L4.69141 7.71577H5.64631L4.87378 8.43819L5.16886 7.26929Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.16886 9.53082L5.46394 10.6997L4.69141 9.9773H5.64631L4.87378 10.6997L5.16886 9.53082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.20109 1.61542L6.49617 2.78432L5.72363 2.0619H6.67854L5.906 2.78432L6.20109 1.61542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.20109 3.87695L6.49617 5.04586L5.72363 4.32343H6.67854L5.906 5.04586L6.20109 3.87695Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.20109 6.13849L6.49617 7.30739L5.72363 6.58497H6.67854L5.906 7.30739L6.20109 6.13849Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.20109 8.40002L6.49617 9.56893L5.72363 8.84651H6.67854L5.906 9.56893L6.20109 8.40002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.23527 0.484619L7.53035 1.65352L6.75781 0.9311H7.71272L6.94018 1.65352L7.23527 0.484619Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.23527 2.74615L7.53035 3.91506L6.75781 3.19264H7.71272L6.94018 3.91506L7.23527 2.74615Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.23527 5.00769L7.53035 6.17659L6.75781 5.45417H7.71272L6.94018 6.17659L7.23527 5.00769Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.23527 7.26929L7.53035 8.43819L6.75781 7.71577H7.71272L6.94018 8.43819L7.23527 7.26929Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.23527 9.53076L7.53035 10.6997L6.75781 9.97724H7.71272L6.94018 10.6997L7.23527 9.53076Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.26847 1.61542L8.56355 2.78432L7.79102 2.0619H8.74592L7.97339 2.78432L8.26847 1.61542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.26847 3.87695L8.56355 5.04586L7.79102 4.32343H8.74592L7.97339 5.04586L8.26847 3.87695Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.26847 6.13849L8.56355 7.30739L7.79102 6.58497H8.74592L7.97339 7.30739L8.26847 6.13849Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.26847 8.40002L8.56355 9.56893L7.79102 8.84651H8.74592L7.97339 9.56893L8.26847 8.40002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3007 0.48468L9.59578 1.65358L8.82324 0.931162H9.77815L9.00561 1.65358L9.3007 0.48468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3007 2.74622L9.59578 3.91512L8.82324 3.1927H9.77815L9.00561 3.91512L9.3007 2.74622Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3007 5.00769L9.59578 6.17659L8.82324 5.45417H9.77815L9.00561 6.17659L9.3007 5.00769Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3007 7.26929L9.59578 8.43819L8.82324 7.71577H9.77815L9.00561 8.43819L9.3007 7.26929Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3007 9.53082L9.59578 10.6997L8.82324 9.9773H9.77815L9.00561 10.6997L9.3007 9.53082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3339 1.61542L10.629 2.78432L9.85645 2.0619H10.8114L10.0388 2.78432L10.3339 1.61542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3339 3.87695L10.629 5.04586L9.85645 4.32343H10.8114L10.0388 5.04586L10.3339 3.87695Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3339 6.13855L10.629 7.30745L9.85645 6.58503H10.8114L10.0388 7.30745L10.3339 6.13855Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3339 8.40009L10.629 9.56899L9.85645 8.84657H10.8114L10.0388 9.56899L10.3339 8.40009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3671 0.484619L11.6622 1.65352L10.8896 0.9311H11.8446L11.072 1.65352L11.3671 0.484619Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3671 2.74615L11.6622 3.91506L10.8896 3.19264H11.8446L11.072 3.91506L11.3671 2.74615Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3671 5.00769L11.6622 6.17659L10.8896 5.45417H11.8446L11.072 6.17659L11.3671 5.00769Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3671 7.26929L11.6622 8.43819L10.8896 7.71577H11.8446L11.072 8.43819L11.3671 7.26929Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3671 9.53076L11.6622 10.6997L10.8896 9.97724H11.8446L11.072 10.6997L11.3671 9.53076Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_185_14990"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.000976562,
    width: 31,
    height: 21,
    rx: 2.625,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagOfTheUnitedStates1);
export default __webpack_public_path__ + "static/media/Flag_of_the_United_States 1.7b3c0df39b8668190757f40f5a6a759a.svg";
export { ForwardRef as ReactComponent };